module.exports = __webpack_public_path__ + "img/bng2.139e7a3f.png";